/** @format */

import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import ByDistrict from "./ByDistrict";
import Add from "./Add";
import Add2 from "./Add2";

function Index() {
  const regionName = useState(JSON.parse(localStorage.getItem("sw_user")).fio);
  return (
    <div>
      <div className='tabs-content table-box extra-tab-css'>
        <Routes>
          <Route path='/' element={<ByDistrict regionName={regionName} />} />
          <Route path='/add1' element={<Add />} />
          <Route path='/add2' element={<Add2 />} />
        </Routes>
      </div>
    </div>
  );
}

export default Index;
